<template>
  <v-container class="py-12">
    <v-row justify="center">
      <v-col
        xl="3"
        style="max-width: 350px;"
      >
        <div class="text-center mb-10">
          <img
            src="@/assets/logo.png"
            style="width: 160px"
          >
        </div>
        <v-card
          color="white"
          class="pa-8 pt-5 elevation-10"
          rounded="lg"
        >
          <form @submit.prevent="login">
            <div class="text-h5 text-center mb-6">
              Sign In
            </div>
            <validation-provider
              v-slot="{ errors }"
              rules="required|email"
              name="E-mail"
            >
              <v-text-field
                v-model="email"
                outlined
                label="E-mail"
                :error-messages="errors"
              />
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              rules="required"
              name="Password"
            >
              <v-text-field
                v-model="password"
                background-color="white"
                type="password"
                outlined
                :error-messages="errors"
                label="Password"
              />
            </validation-provider>
            <v-btn
              block
              large
              type="submit"
              color="primary"
              class="ma-0"
              :loading="submitting"
            >
              <v-icon
                left
                small
              >
                fa fa-sign-in-alt
              </v-icon>
              Login
            </v-btn>
          </form>
        </v-card>

        <v-row
          v-if="$vuetify.breakpoint.xsOnly"
          class="mt-6"
        >
          <v-col cols="4">
            <v-img src="@/assets/eu2.jpg" />
          </v-col>
          <v-col cols="4">
            <v-img src="@/assets/eu1.jpg" />
          </v-col>
          <v-col cols="4">
            <v-img
              src="@/assets/eu3.jpg"
              max-height="40px"
              contain
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        email: null,
        password: null,
        submitting: false
      }
    },
    methods: {
      async login() {
        this.submitting = true

        try {
          await this.$store.dispatch('login', {
            email: this.email,
            password: this.password
          })

          this.$router.push({ name: 'players' })
        } catch (e) {
          if (e.response && e.response.status === 422) {
            this.$store.dispatch('alert', {
              text: e.response.data.message,
              color: 'error'
            })
            return
          }

          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
